import {
    regex    
} from 'react-admin';

// Accepts either a bare 10-digit US number (e.g. 5551234567) or the E.164
// US/Canada form with the +1 country code (e.g. +15551234567). The eligibility
// list uploader standardizes numbers to E.164 (+1), so both shapes must pass.
// Mirrors the +1 handling in hotlineBlocklistValidators/leadValidators.
const PHONE_PATTERN = /^(\+1)?\d{10}$/;
const PHONE_PATTERN_OPTIONAL = /^$|^(\+1)?\d{10}$/;

export const validatePhone = (required = true, message = "Must be a valid phone number") => {
    if (!required) {
        return regex(PHONE_PATTERN_OPTIONAL, message);
    }
    else {
        return regex(PHONE_PATTERN, message);
    }

}

// export const validatePhone = (message = "Must be a valid phone number") => {
    
//     return regex(/^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/, message)
// }

export const validateHexColor = (message = "Must be a valid hex color") => {
    return regex(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, message)
}

export const validateUrl = (message = "Must be a valid url") => {
    return regex(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+(:[0-9]+)?|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/, message)
}

export const validateZip = (message = "Must be a valid ZIP") => {
    return regex(/^[0-9]{5}(?:-[0-9]{4})?$/, message)
}